<div class="content-card">
  <div class="card-inner">
    <p-fluid>
      <div class="font-semibold text-xl mb-4 module-name">
        Package
      </div>


      <p-table #dt [value]="viewModel.packages() || []" [rows]="10" [paginator]="true"
        [globalFilterFields]="['packageName','packageDescription']" [tableStyle]="{ 'min-width': '75rem' }"
        [rowHover]="true" dataKey="id" currentPageReportField="Showing {first} to {last} of {totalRecords} packages"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30]">
        <ng-template #caption>
          <div class="flex flex-col justify-between">
            <div class="flex flex-col items-end gap-3 flex-1 mt-4">
              <div class="flex gap-2" *ngIf="viewModel.isSystemUser()">
                <p-button label="Add" icon="pi pi-plus" severity="info" (click)="viewModel.openNew()" />
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <h5 class="m-0"></h5>
            <p-iconfield>
              <p-inputicon styleClass="pi pi-search" />
              <input pInputText type="text" (input)="viewModel.onGlobalFilter(dt, $event)" placeholder="Search..." />
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <!-- <th style="min-width: 16rem">Client Name</th> -->
            <th pSortableColumn="packageName" style="min-width:16rem">
              Package Name
              <p-sortIcon field="packageName" />
            </th>
            <th style="min-width: 20rem">Description</th>
            <th style="width: 12rem">Action</th>
          </tr>
        </ng-template>

        <ng-template #body let-pkg>
          <tr>
            <!-- <td style="min-width: 16rem">
              {{ pkg.clientTenant?.client?.clientName || '-' }}
            </td> -->
            <td style="min-width: 16rem">
              {{ pkg.packageName || '-' }}
            </td>
            <td style="min-width: 20rem">
              {{ pkg.packageDescription || '-' }}
            </td>
            <td style="width: 12rem">
              <p-button icon="pi pi-pencil" severity="info" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.editPackage(pkg)" pTooltip="Edit" tooltipPosition="top" class="mr-2" />
              <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.deletePackage(pkg)" pTooltip="Delete" tooltipPosition="top" />
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="4" class="noData">No packages found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-fluid>

    <!-- Create/Edit Dialog -->
    <p-dialog [(visible)]="viewModel.packageDialog" [appendTo]="'body'" [style]="{ width: '600px' }"
      [header]="viewModel.isEditMode ? 'Edit Package' : 'Create Package'" [modal]="true" [dismissableMask]="false"
      [blockScroll]="true" [draggable]="false" styleClass="module-name package-dialog"
      (onHide)="viewModel.hideDialog()">
      <ng-template #content>
        <form [formGroup]="viewModel.form" class="p-fluid" autocomplete="off">
          <div class="field">
            <label class="block font-medium mb-2">Name <span class="text-red-500">*</span></label>
            <input type="text" pInputText formControlName="packageName" placeholder="Enter Package Name"
              class="w-full" />
            <small class="text-red-500"
              *ngIf="viewModel.form.get('packageName')?.invalid && viewModel.form.get('packageName')?.touched">
              Name is required.
            </small>
          </div>

          <div class="field">
            <label class="block font-medium mb-2">Description</label>
            <textarea pTextarea formControlName="packageDescription" placeholder="Enter Package Description" rows="3"
              class="w-full"></textarea>
          </div>
        </form>
      </ng-template>

      <ng-template #footer class="mt-2">
        <p-button label="Cancel" icon="pi pi-times" severity="warn" (click)="viewModel.hideDialog()"></p-button>
        <p-button [label]="viewModel.isEditMode ? 'Update' : 'Submit'" icon="pi pi-check" severity="success"
          (click)="viewModel.savePackage()"></p-button>
      </ng-template>
    </p-dialog>

    <p-confirmdialog [style]="{ width: '450px' }"></p-confirmdialog>
  </div>
</div>